module.exports = __webpack_public_path__ + "img/grainsense_logo_white.21bdfe01.png";